/* Sends every waitlist / restock signup on the site to Klaviyo.
 *
 * Account XVHRc2, list "Waistlist" (Tgirgx). This list uses double opt-in:
 * new subscribers must confirm their email before joining the list and
 * becoming eligible for its "Waitlist 2026" flow.
 *
 * Every waitlist box on the site is a Shopify `{% form 'customer' %}` whose
 * hidden contact[tags] contains "waitlist". Those still submit to Shopify
 * natively (that is what tags the customer and shows the success state), so
 * this only adds the Klaviyo call alongside, with keepalive so it survives
 * the navigation the native submit causes.
 *
 * The restock popup (#oos-waitlist) stays open instead of navigating, so it
 * calls koppaWaitlistSubscribe itself and reads the status.
 */
(function () {
  var COMPANY_ID = 'XVHRc2';
  var LIST_ID = 'Tgirgx';
  var POPUP_FORM_ID = 'oos-waitlist';

  /* Resolves to the HTTP status; 202 means Klaviyo accepted the signup. */
  function subscribe(email, options) {
    var settings = options || {};
    var attributes = { email: email };
    if (settings.firstName) attributes.first_name = settings.firstName;
    if (settings.properties) attributes.properties = settings.properties;

    /* GA4: record the signup as its own event so it can be a key event. */
    try {
      if (typeof window.gtag === 'function' && window.KoppaConsent && window.KoppaConsent.analyticsAllowed()) {
        var product = settings.properties && settings.properties['Waitlist Product'] ? settings.properties['Waitlist Product'] : '';
        window.gtag('event', 'waitlist_signup', {
          form_source: settings.source || 'Site waitlist',
          waitlist_product: product,
          page_path: window.location.pathname
        });
        window.gtag('event', 'generate_lead', { lead_source: 'waitlist', waitlist_product: product });
      }
    } catch (_) { /* analytics must never block the signup */ }

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: settings.source || 'Site waitlist',
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    }).then(function (response) {
      return response.status;
    });
  }

  window.koppaWaitlistSubscribe = subscribe;

  function waitlistTags(form) {
    var tags = form.querySelector('input[name="contact[tags]"]');
    var value = tags && tags.value ? tags.value : '';
    return value.indexOf('waitlist') === -1 ? null : value;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.id === POPUP_FORM_ID) return;

      var tags = waitlistTags(form);
      if (!tags) return;

      var input = form.querySelector('input[type="email"]');
      var email = input && input.value ? input.value.trim() : '';
      if (!email) return; /* let the browser's own validation handle it */

      var name = form.querySelector('input[name="contact[first_name]"]');
      var product = '';
      tags.split(',').forEach(function (rawTag) {
        var tag = rawTag.trim();
        if (tag.indexOf('restock-') === 0) product = tag.slice(8);
      });

      subscribe(email, {
        firstName: name && name.value ? name.value.trim() : '',
        source: 'Site waitlist — ' + (form.id || 'form'),
        properties: { 'Waitlist Product': product, 'Waitlist Tags': tags }
      })['catch'](function () {
        /* The native Shopify submit still captures them; nothing to show. */
      });
    },
    true
  );
})();
